<template lang="pug">
  .image-preview.media-preview
    PreviewTemplate
      template(v-slot:media-item)
        v-responsive(:aspect-ratio="aspectRatio")
          .image-preview__container(
            :class="{ 'image-preview__container--clickable': showPreview }"
            @click="showPreview && openPreviewDialog()"
          )
            v-img.image-preview__thumbnail(
              :src="thumbnail"
              :aspect-ratio="aspectRatio"
              :gradient="gradient"
              :class="customClass"
            )
              template(v-slot:placeholder)
                ImageLoading
            v-chip.ma-2(color="primary" label x-small) Kapak Görseli
            v-btn.video-cover-button(fab dark x-small color="cyan")
              v-icon content_copy
            v-btn.play-button(fab x-small)
              v-icon mdi-play
            v-btn.preview-button(
              v-if="showPreview"
              fab
              dark
              x-small
              color="rgba(0, 0, 0, 0.5)"
              @click.stop="openPreviewDialog"
            )
              v-icon mdi-eye
      template(v-slot:card-actions)
        slot(name="card-actions")
    Dialog(
      v-if="showPreview"
      v-model="previewDialog.isActive.value"
      max-width="90%"
      :title="''"
      @close="previewDialog.close"
    )
      template(v-slot:dialog-content)
        .image-preview-modal
          v-img(
            :src="fullSizeImage"
            contain
            max-height="85vh"
          )
            template(v-slot:placeholder)
              ImageLoading
</template>

<script>
import { computed } from 'vue';
import { MediaTypes, MediaThumbnails } from '../constants';
import PreviewTemplate from './PreviewTemplate.vue';
import ImageLoading from './ImageLoading.vue';
import { useDialog } from '@/helpers/misc/dialog';
import { Dialog } from '@/components/misc/dialog';
import getImageUrl from '@/helpers/media/photo/getImageUrl';

export default {
  name: 'ImagePreview',
  components: {
    PreviewTemplate,
    ImageLoading,
    Dialog,
  },
  props: {
    src: {
      type: String,
      default: '',
    },
    aspectRatio: {
      type: Number,
      required: false,
      default: 1,
    },
    gradient: {
      type: String,
      required: false,
      default: null,
    },
    customClass: {
      type: String,
      required: false,
    },
    showPreview: {
      type: Boolean,
      required: false,
      default: false,
    },
    imagePreviewSize: {
      type: Number,
      required: false,
      default: null,
    },
  },
  setup(props) {
    // Thumbnail: If imagePreviewSize is provided, use resized URL; otherwise use src directly
    const thumbnail = computed(() => {
      if (!props.src) {
        return MediaThumbnails[MediaTypes.IMAGE];
      }

      return props.imagePreviewSize ? getImageUrl(props.src, props.imagePreviewSize) : props.src;
    });

    // Full size image: Use original size (no resize parameter)
    const fullSizeImage = computed(() => {
      if (!props.src) {
        return MediaThumbnails[MediaTypes.IMAGE];
      }

      return getImageUrl(props.src);
    });

    const previewDialog = useDialog();

    const openPreviewDialog = () => {
      previewDialog.open();
    };

    return {
      thumbnail,
      fullSizeImage,
      previewDialog,
      openPreviewDialog,
    };
  },
};
</script>

<style lang="scss" scoped>
.image-preview {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .preview-button {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 10;
    width: 48px;
    height: 48px;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.2s ease-in-out;

    .v-icon {
      font-size: 24px;
    }
  }

  .image-preview__container {
    position: relative;
    width: 100%;
    height: 100%;

    &--clickable {
      cursor: pointer;

      &:hover {
        .preview-button {
          opacity: 1;
        }
      }
    }
  }

  .video-cover-button {
    position: absolute;
    top: 5px;
    right: 5px;
    display: none;
    width: 24px;
    height: 24px;

    .v-icon {
      font-size: 14px;
    }
  }

  .play-button {
    position: absolute;
    top: calc(50% - 16px);
    right: calc(50% - 16px);
    display: none;
  }

  .v-chip {
    display: none;
  }
}

.image-preview-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 20px;
}
</style>
